import React, { useState, useEffect, useLayoutEffect, useRef } from 'react'
import { useSwipeable } from 'react-swipeable';
import ScheduleView from '../../ScheduleView';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion, faThumbsUp, faUser, faImage, faCircleInfo, faLock } from '@fortawesome/free-solid-svg-icons';
import { isMobile } from 'react-device-detect';

const CalendarView = ({ screenObj, setScheduleSelection, scheduleSelection, json, handleChangeUserSelections, userSelections, setPage, userGUID, showInfoModal, online, selectedGroupGUID, getSchedule }) => {

    const { windowWidth, windowHeight, optionsBarHeight } = screenObj;
    const scheduleContainer = useRef(null);
    const [scheduleSize, setScheduleSize] = useState({ width: windowWidth, height: windowHeight - optionsBarHeight });
    useLayoutEffect(() => {
        const container = scheduleContainer.current;
        const resize = () => setScheduleSize({ width: container.clientWidth, height: container.clientHeight });
        resize();
        const observer = new ResizeObserver(resize);
        observer.observe(container);
        return () => observer.disconnect();
    }, []);

    const [selectedDate, setSelectedDate] = useState(localStorage.getItem('selectedDate') != null ? parseInt(localStorage.getItem('selectedDate')) : 0);
    const handlers = useSwipeable({
        onSwipedLeft: () => {
            if (selectedDate < json.length - 1) setSelectedDate((prev) => prev + 1);
        },
        onSwipedRight: () => {
            if (selectedDate > 0) setSelectedDate((prev) => prev - 1);
        },
        onSwipedDown: () => {
            getSchedule();
        },
        preventDefaultTouchmoveEvent: true,
        trackMouse: true // Optional: Allows swipe detection with a mouse
    });

    const weekdayInTZ = (dateStr, tz = "America/Los_Angeles") => {
        const [y, m, d] = dateStr.split("-").map(Number);
        const utcDate = new Date(Date.UTC(y, m - 1, d, 12, 0, 0)); // noon UTC
        return new Intl.DateTimeFormat("en-US", { weekday: "short", timeZone: tz })
            .format(utcDate)
            .toUpperCase();
    };

    useEffect(() => {
        localStorage.setItem('selectedDate', selectedDate)
    }, [selectedDate]);

    return (
        <div className={`calendar-view${showInfoModal ? ' blur' : ''}`}>
            <div className="button-container calendar-toolbar" style={{ gridTemplateColumns: `repeat(${json.length}, minmax(0, 1fr)) 12px repeat(3, minmax(0, 36px)) 12px ${isMobile ? 'minmax(0, 36px) 12px ' : ''}minmax(0, 36px)` }}>
                {json.map((date, dateIndex) => (
                    <button
                        key={dateIndex}
                        onClick={() => setSelectedDate(dateIndex)}
                        className={selectedDate === dateIndex ? 'btn selected' : 'btn'}
                    >
                        {weekdayInTZ(date.date, date.timezone)}
                    </button>
                ))}

                <span aria-hidden="true" />
                <button
                    aria-label="Mark sets as maybe"
                    onClick={() => setScheduleSelection(3)} className={scheduleSelection === 3 ? 'btn btn-ranking-3' : 'btn'}>
                    <FontAwesomeIcon icon={faQuestion} />
                </button>
                <button
                    aria-label="Mark sets as must see"
                    onClick={() => setScheduleSelection(4)} className={scheduleSelection === 4 ? 'btn btn-ranking-4' : 'btn'}>
                    <FontAwesomeIcon icon={faThumbsUp} />
                </button>
                <button
                    aria-label="Lock selections or view friends"
                    onClick={() => setScheduleSelection(0)} className={scheduleSelection === 0 ? 'btn btn-primary' : 'btn'}>
                    <FontAwesomeIcon icon={selectedGroupGUID ? faCircleInfo : faLock } />
                </button>

                <span aria-hidden="true" />
                {isMobile ? <><button onClick={() => setPage('options')} className="btn"
                    aria-label="Create wallpaper"
                >
                    <FontAwesomeIcon icon={faImage} />
                </button><span aria-hidden="true" /></> : <></>}
                <button disabled={!online} onClick={() => setPage('user')} className={`btn ${userGUID && online ? 'selected' : ''}`}
                    aria-label="Your account"
                >
                    <FontAwesomeIcon icon={faUser} />
                </button>
            </div>
            <div id="exportSourceInnerHTML"
                className="calendar-content"
                {...handlers}
                ref={element => {
                    scheduleContainer.current = element;
                    handlers.ref(element);
                }}
                style={{
                    position: 'relative',
                    overflow: 'hidden',
                    touchAction: 'pan-y',
                }}>
                <div
                    id="dayPaneContainer"
                    style={{
                        height: '100%',
                        justifyContent: 'center',
                        display: 'flex',
                        width: '100%',
                    }}>
                    <ScheduleView
                        data={json[selectedDate]}
                        width={scheduleSize.width}
                        height={scheduleSize.height}
                        scheduleSelection={scheduleSelection}
                        handleChangeUserSelections={handleChangeUserSelections}
                        userSelections={userSelections}
                        showGroupSchedules={selectedGroupGUID !== '' && online}
                    />
                </div>
            </div >
        </div>
    )
}

export default CalendarView;
